<template>
  <div class="home--cup col__black">
    <div class="home--cup__wrapper">
      <ImageWrapper
        src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/cup_bg_desktop.jpg"
        alt=""
        class="home--cup__bg d-none d-md-block"
      />

      <ImageWrapper
        src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/cup_bg_mobile.jpg"
        alt=""
        class="home--cup__bg d-block d-md-none"
      />

      <div class="home--cup__table--wrapper">
        <div class="home--banner__mobile--container">
          <div
            class="h1 home--cup__title text-center txt-upper mB8"
            v-html="$t('cups.title')"
          ></div>
          <p
            class="body-small text-center home--cup__desc mB24"
            v-html="$t('cups.desc')"
          ></p>
        </div>
        <div>
          <div class="home--cup__cups">
            <div class="row gx-0">
              <div class="col-12 col-md-6">
                <div class="home--cup__cup--content up">
                  <div class="row">
                    <div
                      class="col"
                      v-for="(item, index) in cups"
                      v-if="index < 3"
                    >
                      <div class="home--cup__cup--col">
                        <div class="mB14">
                          <p class="body-small fw-bold text-center mB12">
                            {{ item.name }}
                          </p>
                          <p class="body-small text-center">{{ item.cap }}</p>
                        </div>
                        <div class="home--cup__cup--wrapper">
                          <ImageWrapper
                            class="home--cup__cup--img"
                            :class="[`cup_${index + 1}`]"
                            :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${item.img}`"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <ImageWrapper
                    class="home--cup__table--mobile up d-block d-md-none"
                    src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/upper_table.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="home--cup__cup--content down">
                  <div class="row">
                    <div
                      class="col"
                      v-for="(item, index) in cups"
                      v-if="index >= 3"
                    >
                      <div class="home--cup__cup--col">
                        <div class="m14">
                          <p class="body-small fw-bold text-center mB12">
                            {{ item.name }}
                          </p>
                          <p class="body-small text-center">{{ item.cap }}</p>
                        </div>
                        <div class="home--cup__cup--wrapper">
                          <ImageWrapper
                            class="home--cup__cup--img"
                            :class="[`cup_${index + 1}`]"
                            :src="`https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/${item.img}`"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <ImageWrapper
                    class="home--cup__table--mobile down d-block d-md-none"
                    src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/lower_table.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <ImageWrapper
            src="https://s3.ap-southeast-1.amazonaws.com/nespresso.web/vertuo_pop/assets/images/cup_table.png"
            class="home--cup__table--img d-none d-md-block"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "../atoms/ImageWrapper.vue";

export default {
  name: "HomeCups",
  components: {
    ImageWrapper,
  },
  computed: {
    /**
     * Returns the cups data from translations
     * @returns {Array} Array of cup objects with name, cap, and img properties
     */
    cups() {
      return this.$t("cups.cups");
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  .home--cup {
    width: 100%;
    overflow-x: hidden;
    background-color: color(whiteAbs);
    &__title {
      letter-spacing: 0.15em;
      line-height: 1.2em;

      @include media-breakpoint-down(md) {
        font-size: rem(24);
      }
    }

    &__desc {
      min-height: rem(120);

      @include media-breakpoint-down(md) {
        min-height: inherit;
      }
    }

    &__cups {
      padding: 0 rem(20);

      .cup_1 {
        width: 72/133 * 100%;
      }

      .cup_2 {
        width: 72/133 * 100%;
      }

      .cup_3 {
        width: 85/133 * 100%;
      }

      .cup_4 {
        width: 97/133 * 100%;
      }

      .cup_5 {
        width: 106/133 * 100%;
      }

      .cup_6 {
        width: 100/133 * 100%;
      }
    }

    &__table--mobile {
      width: calc(100% + 56px);
      margin-left: rem(-24);
      margin-top: rem(-26);
    }
    &__cup {
      &--wrapper {
        display: flex;
        justify-content: center;
      }

      &--img {
        transform: translateX(10%);
        width: 100%;

        // @include media-breakpoint-down(md) {
        //   margin-top: rem(12);
        //   // width: auto;
        //   // object-fit: contain;
        //   // max-height: 138px;
        // }
      }

      &--col {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
      }

      // &--row.row {
      //   --bs-gutter-x: #{rem(4)};
      // }

      &--content {
        height: 100%;
        @include media-breakpoint-down(md) {
          height: inherit;
        }

        .row {
          height: 100%;
          --bs-gutter-x: #{rem(4)};
        }

        &.up {
          @include media-breakpoint-down(md) {
            width: 75%;
          }
        }

        &.down {
          @include media-breakpoint-down(md) {
            width: 90%;
          }
        }
      }
    }

    &__wrapper {
      max-width: rem(1440);
      margin-left: auto;
      margin-right: auto;
      position: relative;
    }

    &__bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &__table {
      &--wrapper {
        position: relative;
        max-width: rem(797);
        width: 100%;
        // min-height: rem(587);
        margin-left: auto;
        margin-right: auto;
        padding-top: rem(60);
        // padding-left: rem(12);
        // padding-right: rem(12);

        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      &--img {
        width: 100%;
        margin-top: -3%;
      }
    }
  }
}
</style>
